import React from 'react';
import {FiLock} from 'react-icons/fi';

export function KeysLock({...rest}) {
  return <FiLock size={35} {...rest} />;
}
